import { useContext } from 'react';
import { AuthContext } from 'src/auth/AuthContext';

export const useAuth = () => useContext(AuthContext);
